import cn from "@/helpers/classNames";

import { IntegrationLogo } from "./IntegrationLogo";

type Size = "1xs" | "xs" | "sm" | "md" | "lg" | "xl";

const sizeClasses: Record<Size, string> = {
  "1xs": "max-w-4 h-4",
  xs: "max-w-5 h-5",
  sm: "max-w-6 h-6",
  md: "max-w-8 h-8",
  lg: "max-w-10 h-10",
  xl: "max-w-12 h-12",
};

export function IntegrationLogoBox(props: {
  id: string;
  size?: Size;
  className?: string;
}) {
  const containerClass = sizeClasses[props.size ?? "xs"];
  return (
    <IntegrationLogo
      id={props.id}
      className={cn("object-contain", containerClass, props.className)}
    />
  );
}
